


import React from 'react';
import { useSelector } from 'react-redux';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import useCart from './oldComponent/useCart';

const CartIcon = () => {
  // const cart = useSelector(state => state.cart.items|| []); // או לפי המבנה של ה-state שלך
  const cart = useSelector(state => state.cart.items)    //בשביל לזהות אם המוצר קיים כבר בעגלה

  return (
  <Badge badgeContent={cart?.length || 0} color="secondary">
    <ShoppingCartIcon sx={{ fontSize: 36, color: "#58A76B" }} />
  </Badge>
);
};

export default CartIcon;
